import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineRosey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.883 6.873a1.91 1.91 0 0 1 2.057.025l4.809 3.195.044.03.01.007 2.805 1.741a.59.59 0 0 1 .19.846.687.687 0 0 1-.918.18l-1.35-.838v6.085c0 .94-.916 1.656-1.931 1.656H7.01c-.458 0-.81-.35-.81-.76s.353-.76.81-.76h8.392a.5.5 0 0 0 .5-.5v-6.118a.5.5 0 0 0-.223-.417l-4.677-3.107-.108-.072-.11.069-1.679 1.054a.843.843 0 0 1-1.128-.215.73.73 0 0 1 .227-1.046z"
    />
    <path
      fill="currentColor"
      d="M3.804 8.521c.203-.695 1.189-.695 1.392 0l.297 1.016a2.9 2.9 0 0 0 1.97 1.97l1.016.297c.695.203.695 1.189 0 1.392l-1.016.297a2.9 2.9 0 0 0-1.97 1.97l-.297 1.016c-.203.695-1.189.695-1.392 0l-.297-1.016a2.9 2.9 0 0 0-1.97-1.97l-1.016-.297c-.695-.203-.695-1.189 0-1.392l1.016-.297a2.9 2.9 0 0 0 1.97-1.97zM15.536 1.348c.136-.464.792-.464.928 0l.198.676c.185.633.68 1.129 1.314 1.314l.676.198c.464.136.464.792 0 .928l-.676.198a1.94 1.94 0 0 0-1.314 1.314l-.198.676c-.136.464-.792.464-.928 0l-.198-.676a1.93 1.93 0 0 0-1.314-1.314l-.676-.198c-.464-.136-.464-.792 0-.928l.676-.198a1.93 1.93 0 0 0 1.314-1.314z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.955.488a2.012 2.012 0 1 1 0 4.024 2.012 2.012 0 0 1 0-4.024m0 1.057a.955.955 0 1 0 0 1.91.955.955 0 0 0 0-1.91"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStreamlineRosey;
